import React from 'react';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';

import { IFaqsProps } from '../../types';
import { TableButtonDelete } from './TableButtonDelete';
import { TableButtonEdit } from './TableButtonEdit';

interface ITableColumnControllerProps {
  handleDeleteFunction: (tId: string) => Promise<void>;
  refetch: () => void;
  dataList?: IFaqsProps[];
}

export function TableColumnController({ handleDeleteFunction, refetch, dataList }: ITableColumnControllerProps) {
  const columns: ColumnsType<IFaqsProps> = [
    {
      title: 'Titulo',
      dataIndex: 'title',
      sorter: true,
    },

    {
      title: 'Conteudo',
      dataIndex: 'content',
      sorter: true,
    },

    {
      title: 'Data de criação',
      dataIndex: 'createdAt',
      sorter: true,
    },

    {
      title: 'Ações',
      dataIndex: 'actions',
      render: (_, item) => {
        return (
          <div className="table-actions">
            <TableButtonEdit interationId={String(item.id)} refetch={refetch} data={item} />
            <TableButtonDelete handleDeleteFunction={handleDeleteFunction} contactId={String(item.id)} />
          </div>
        );
      },
    },
  ];

  const data: any[] = [];

  dataList?.forEach(item => {
    data.push({
      id: item.id,
      key: item.id,
      title: item.title,
      content: item.content,
      faq_category_id: item.faq_category_id,
      createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
    });
  });

  return { columns, data };
}
